const landingDatas = [
    {
        nameKey: 'menu.new_game',
        link : 'newgame'
    },
    {
        nameKey: 'menu.favorite_game',
        link : 'favorite'
    },
    {
        nameKey: 'menu.slot',
        link : 'slot'
    },
    {
        nameKey: 'menu.live',
        link : 'live'
    }
] ;

module.exports = { landingDatas } ;